import { action } from 'easy-peasy';
import { IActionUpdateIcd10Code } from '../types';

const updateIcd10Code: IActionUpdateIcd10Code = action((state, payload) => {
  state.items = state.items.map(item => (item.id === payload.id ? { ...item, ...payload } : item));
});

export default updateIcd10Code;
